<div mat-dialog-content>
    <div>{{ data }}</div>
</div>
<div mat-dialog-actions>
    <button mat-dialog-close class="app-raised-button ml-auto">close</button>
</div>
